<template>
  <div class="currency-toggle">
    <h6 class="currency-toggle-title">
      <svg class="currency-toggle-title__icon">
        <use xlink:href="#svg-wallet"></use>
      </svg>
      {{ messages?.currency }}
    </h6>
    <div class="currency-toggle-items">
      <button
        v-for="item in currencyList"
        :key="item.ID"
        type="button"
        class="currency-toggle-button"
        :class="{ 'currency-toggle-button__active': item.active }"
        @click="changeCurrency(item)"
      >
        {{ item?.UF_PRINT_NAME }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useCurrencies from '@use/useCurrencies/useCurrencies';
import { useStore } from '@/store';
import { computed } from 'vue';

const { state } = useStore();
const currencies = useCurrencies();

const messages = computed(() => state.results.messages);
const { currencyList, changeCurrency } = currencies;
</script>

<style lang="scss" scoped>
.currency-toggle {
  padding: 16px;
}
.currency-toggle-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  margin-bottom: 16px;
  &__icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
}
.currency-toggle-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.currency-toggle-button {
  display: flex;
  align-items: center;
  border: 1px solid var(--border-grey);
  padding: 4px 12px;
  min-height: 32px;
  font-size: 14px;
  font-weight: 600;
  line-height: 125%;
  &__active {
    background-color: var(--background-black);
    border-color: var(--background-black);
    color: #fff;
  }
}
</style>
